import React from 'react';
import { partners } from '../data/mock';

const sources = (domain) => [
  `https://logo.uplead.com/${domain}`,
  `https://www.google.com/s2/favicons?domain=${domain}&sz=256`
];

const PartnerLogo = ({ name, domain }) => {
  const [idx, setIdx] = React.useState(0);
  const [failed, setFailed] = React.useState(false);
  const list = sources(domain);

  const handleError = () => {
    if (idx < list.length - 1) setIdx(idx + 1);
    else setFailed(true);
  };

  const handleLoad = (e) => {
    // If image is too small (typical uplead "not found" xml), fallback
    const img = e.target;
    if (img.naturalWidth < 24 || img.naturalHeight < 24) {
      handleError();
    }
  };

  return (
    <div className="flex items-center justify-center h-24 px-14 min-w-[240px]">
      {!failed ? (
        <img
          src={list[idx]}
          alt={name}
          onError={handleError}
          onLoad={handleLoad}
          className="max-h-16 max-w-[200px] object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
        />
      ) : (
        <span className="font-serif text-2xl text-[#010c23]/60 whitespace-nowrap">{name}</span>
      )}
    </div>
  );
};

const PartnersMarquee = () => {
  const list = [...partners, ...partners];
  return (
    <div className="marquee py-6">
      <div className="marquee-inner">
        {list.map((p, i) => (
          <PartnerLogo key={`${p.name}-${i}`} name={p.name} domain={p.domain} />
        ))}
      </div>
    </div>
  );
};

export default PartnersMarquee;
